import { FixMeLater, SubGroup } from "@shared/types";

export interface BaseConfigurationItem<T> {
  constraints: FixMeLater;
  outcome: T;
}

export interface ConfigurationOption {
  value?: string | number;
  name: string | number;
}

export interface ConfigurationItem {
  name: BaseConfigurationItem<string>[];
  data: ConfigurationItem[];
  is_section_header?: BaseConfigurationItem<boolean>[];
  default_display?: BaseConfigurationItem<string>[];
  options?: BaseConfigurationItem<
    ConfigurationOption | ConfigurationOption[]
  >[];
  prefix_type?: BaseConfigurationItem<string | number>[];
  prefix?: BaseConfigurationItem<string | number>[];
  field_type?: BaseConfigurationItem<number>[];
  value?: BaseConfigurationItem<any>[];
  should_display?: BaseConfigurationItem<boolean>[];
  uuid?: string;
  chosen?: boolean;
}

export type IdToValue = Record<number, number | null>;

export enum AutoTradingType {
  LEGACY = 1,
  BOT = 2,
}

export interface AutoTradingGroupsData {
  [AutoTradingType.BOT]: number[];
  [AutoTradingType.LEGACY]: number[];
}

export interface LiveUpdateChannelsResponse {
  groups_data: SubGroup[];
}
